<div class="d-flex align-item-center position-relative">
  <div
    class="process-settings"
    *ngIf="
      lmService.contract_show_div == 'edit_contract' &&
      (user_role == 'master admin' ||
        user_role == 'operations manager' ||
        user_permission.includes('contract.manage') ||
        user_permission.includes('contract.delete'))
    ">
    <img [src]="common_images?.delete_icon" alt="delete" width="16px" (click)="deleteContract()" />
  </div>
</div>

<form #contractForm="ngForm" #contractFormElement>
  <div class="form-header" *ngIf="lmService.contract_show_div == 'add_contract' && contract">
    <div>
      <h2 class="mb-2 main-heading">
        Contract <span *ngIf="property_name"> - {{ property_name }}</span>
      </h2>
    </div>
    <div class="flexCenterEnd">
      <button class="_cancel-btn mr-2" (click)="closeContract()">Cancel</button>
      <button class="mr-2 _outline-btn" (click)="singleClick = true; saveContract('onlySave', contractForm)" [class.disabled]="singleClick">
        Save
      </button>
      <button class="_primary-btn" (click)="singleClick = true; saveContract('save', contractForm)" [class.disabled]="singleClick">
        Save & Close
      </button>
    </div>
  </div>
  <div
    class="form-header"
    *ngIf="
      lmService.contract_show_div == 'edit_contract' &&
      (this.userPermission.includes('contract.manage') ||
        this.userPermission.includes('contract.edit') ||
        this.userRole == 'master admin' ||
        this.userRole == 'operations manager')
    ">
    <div>
      <h2 class="mb-2 main-heading">
        Contract <span *ngIf="buyerName"> - {{ buyerName }}</span>
      </h2>
    </div>
    <div class="flexCenterEnd">
      <button class="_cancel-btn mr-2" (click)="closeContract()">Cancel</button>
      <button class="mr-2 _outline-btn" (click)="singleClick = true; updateContract('onlySave', contractForm)" [class.disabled]="singleClick">
        Save
      </button>
      <button class="_primary-btn" (click)="singleClick = true; updateContract('save', contractForm)" [class.disabled]="singleClick">
        Save & Close
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-8">
      <div class="form-group cs-border">
        <app-collapse-box
          [contractBorder]="'border-0'"
          [headingClassName]="'f-12'"
          [heading]="'Contracts Details'"
          [isCollapsed]="defaultFormSetting.contract"
          (TriggerAction)="CollapseBoxActionTriggered($event)">
          <div class="pb-2 pt-2" *ngIf="numOfNotValidFields > 0">
            <p class="form-error font-weight-bold cursor-pointer" (click)="notDisplayRequiredMessage = false">
              You have {{ numOfNotValidFields }} notifications. Select to view.
            </p>
            <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
              <ul>
                <li class="pb-1 cursor-pointer" *ngFor="let message of requiredErrorMessages" (click)="ActivateTabIndexByError(message.field)">
                  {{ message?.message | capitalizephrase }}
                </li>
              </ul>
            </div>
          </div>
          <div class="text-right" *ngIf="contract.cancelledDate">
            <p>Cancelled - {{ contract.cancelledDate | date: 'dd/MM/yyyy' }}</p>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6 task-contact">
              <label class="f-12 mb-1">Listing</label>
              <ng-select
                [items]="properties"
                bindLabel="property_address"
                bindValue="_id"
                [searchable]="true"
                [multiple]="false"
                [(ngModel)]="contract.listingid"
                name="listingid"
                placeholder="Select"
                [ngClass]="{ '_input-error': isFormValueValid('listingid') && !contract.listingid }"
                [clearable]="false"
                (change)="contractPreFilled(true)">
                <ng-template ng-label-tmp let-item="item">
                  <div class="d-flex align-items-center cursor-pointer h-17">
                    <p class="ng-value-label" (click)="openRightModal(item, 'edit_listing_property')">
                      {{ item.property_address }}
                    </p>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span>{{ item.property_address }}</span>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3">
              <label class="f-12 mb-1"></label>
              <ng-select
                class="waning-tag-contract mt-2"
                [items]="contractService.contract_status"
                [(ngModel)]="contract.contractStatus"
                name="contractStatus"
                bindLabel="tag_name"
                bindValue="tag_name"
                [searchable]="true"
                [clearable]="false"
                placeholder="Contract Status"
                [ngClass]="{ '_input-error': isFormValueValid('contractStatus') && !contract.contractStatus }">
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3 position-relative">
              <label class="f-12 mb-1"></label>
              <ng-select
                class="primary-tag-contract mt-2"
                [items]="contractService.offer_status"
                [(ngModel)]="contract.offer_status"
                name="offer_status"
                bindLabel="tag_name"
                bindValue="tag_name"
                [searchable]="false"
                [ngClass]="{ '_input-error': isFormValueValid('offer_status') && !contract.offer_status }"
                [clearable]="false"
                placeholder="Offer Status"
                (change)="acceptDecline(true)">
              </ng-select>
              <ng-container *ngIf="is_cancelled">
                <div class="cancelled-contract">
                  <div class="col-sm-12 mt-3">
                    <p class="mb-1">Cancel Date</p>
                    <p-calendar
                      name="cancelledDate"
                      [ngClass]="{ '_input-error': isFormValueValid('cancelledDate') && !contract.cancelledDate }"
                      [firstDayOfWeek]="1"
                      dateFormat="dd/mm/yy"
                      [(ngModel)]="contract.cancelledDate">
                    </p-calendar>
                  </div>
                  <div class="text-right mt-3">
                    <button class="_cancel-btn mr-2" (click)="is_cancelled = false">Cancel</button>
                    <button class="_outline-btn" (click)="is_cancelled = false">Save</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="form-row mt-3">
            <div class="form-field">
              <label class="f-12 mb-1">Seller</label>
              <re-multiselect
                [module]="'contacts'"
                [truncate]="20"
                [selected_ids]="contract.seller"
                (onUpdate)="onUpdateMSelect($event, 'seller')"
                (editRecord)="editRecord($event)"
                [isEmail]="true"
                [placeholder]="'Select Seller'"
                (createNew)="openRightModal(null, 'add_contact')"
                [isCreateNew]="true"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
            <div class="form-field">
              <label class="f-12 mb-1">Seller's Solicitor</label>
              <re-multiselect
                [module]="'contacts'"
                [truncate]="20"
                [selected_ids]="contract.sellerSolicitor"
                (onUpdate)="onUpdateMSelect($event, 'sellerSolicitor')"
                (editRecord)="editRecord($event)"
                [placeholder]="'Select Sellers Solicitor'"
                (createNew)="openRightModal(null, 'add_contact')"
                [isCreateNew]="true"
                [isEmail]="true"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
            <div class="form-field">
              <label class="f-12 mb-1">Buyer</label>
              <re-multiselect
                [module]="'contacts'"
                [truncate]="20"
                [selected_ids]="contract.buyer"
                (onUpdate)="onUpdateMSelect($event, 'buyer')"
                (editRecord)="editRecord($event)"
                [isEmail]="true"
                [placeholder]="'Select Buyer'"
                (createNew)="openRightModal(null, 'add_contact')"
                [isCreateNew]="true"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
            <div class="form-field">
              <label class="f-12 mb-1">Buyer's Solicitor</label>
              <re-multiselect
                [module]="'contacts'"
                [truncate]="20"
                [selected_ids]="contract.buyerSolicitor"
                (onUpdate)="onUpdateMSelect($event, 'buyerSolicitor')"
                (editRecord)="editRecord($event)"
                [placeholder]="'Select Buyers Solicitor'"
                (createNew)="openRightModal(null, 'add_contact')"
                [isCreateNew]="true"
                [isEmail]="true"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-md-4 mt-3">
              <label class="f-12 mb-1">Listing Agent</label>
              <ng-select
                [items]="contractService.office_staff"
                [(ngModel)]="contract.listingAgent"
                [ngClass]="{ '_input-error': isFormValueValid('listingAgent') && !contract.listingAgent }"
                name="listingAgent"
                bindLabel="full_name"
                bindValue="full_name"
                [searchable]="true"
                [clearable]="false"
                placeholder="Select">
                <ng-template ng-option-tmp let-item="item">
                  <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <p>{{ item.full_name }}</p>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-4 mt-3">
              <label class="f-12 mb-1">Managing Agent</label>
              <ng-select
                [items]="contractService.office_staff"
                [(ngModel)]="contract.managingAgent"
                [ngClass]="{ '_input-error': isFormValueValid('managingAgent') && !contract.managingAgent }"
                name="managingAgent"
                bindLabel="full_name"
                bindValue="full_name"
                [searchable]="true"
                [clearable]="false"
                placeholder="Select">
                <ng-template ng-option-tmp let-item="item">
                  <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <p>{{ item.full_name }}</p>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-sm-12 col-md-4 mt-3">
              <label class="f-12 mb-1">Selling Agent</label>
              <ng-select
                [items]="contractService.office_staff"
                [(ngModel)]="contract.sellingAgent"
                [ngClass]="{ '_input-error': isFormValueValid('sellingAgent') && !contract.sellingAgent }"
                name="sellingAgent"
                bindLabel="full_name"
                bindValue="full_name"
                [searchable]="true"
                [clearable]="false"
                placeholder="Select">
                <ng-template ng-option-tmp let-item="item">
                  <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <p>{{ item.full_name }}</p>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </app-collapse-box>
      </div>

      <div class="form-group cs-border">
        <app-collapse-box
          [contractBorder]="'border-0'"
          [headingClassName]="'f-12'"
          [heading]="'Offer Terms'"
          [isCollapsed]="defaultFormSetting.offerTerms"
          (TriggerAction)="CollapseBoxActionTriggered($event)">
          <div class="row mt-3">
            <div class="col-sm-4">
              <p class="f-12 mb-1">Date Offer Received</p>
              <div class="w-100">
                <p-calendar
                  name="dateOffer"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="contract.dateOffer"
                  (onSelect)="selectDate('dateOffer')"
                  [ngClass]="{ '_input-error': isFormValueValid('dateOffer') && !contract.dateOffer }">
                </p-calendar>
              </div>
            </div>
            <div class="col-sm-4 mt-xs-3">
              <p class="f-12 mb-1">Offer Price</p>
              <app-price-input [field_value]="contract.offerPrice" (onUpdate)="updatePrice($event, 'offer_price')"> </app-price-input>
            </div>
            <div class="col-sm-4 mt-xs-3">
              <p class="f-12 mb-1">Settlement Term</p>
              <div class="w-100 d-flex align-items-center">
                <input
                  type="text"
                  name="settlementTerm"
                  step="any"
                  [(ngModel)]="contract.settlementTerm"
                  class="doller-indent"
                  (input)="changeDue()"
                  [ngClass]="{ '_input-error': isFormValueValid('settlementTerm') && !contract.settlementTerm }" />
              </div>
              <p class="daystext">Days from Contract Date</p>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="f-12 mb-1">Initial deposit amount</label>
              <div class="w-100 d-flex align-items-center">
                <app-price-input [field_value]="contract.initialDepositAmount" (onUpdate)="updatePrice($event, 'initial_deposit_amount')">
                </app-price-input>
              </div>
              <p class="daystext"></p>
            </div>
            <div class="col-sm-4 mt-xs-3">
              <label class="f-12 mb-1">Payable upon</label>
              <div class="w-100 d-flex align-items-center">
                <input
                  type="text"
                  name="initialDepositAmountPayable"
                  [ngClass]="{
                    '_input-error': isFormValueValid('initialDepositAmountPayable') && !contract.initialDepositAmountPayable,
                  }"
                  [(ngModel)]="contract.initialDepositAmountPayable"
                  class="doller-indent"
                  (input)="changeDue()" />
              </div>
              <p class="daystext">Days from Contract Date</p>
            </div>
            <div class="col-sm-4 mt-xs-3">
              <label class="f-12 mb-1">Building and Pest Condition</label>
              <div class="w-100 d-flex align-items-center">
                <input
                  type="text"
                  name="buildingPestTerm"
                  [(ngModel)]="contract.buildingPestTerm"
                  class="doller-indent"
                  [ngClass]="{ '_input-error': isFormValueValid('buildingPestTerm') && !contract.buildingPestTerm }"
                  (input)="changeDue()" />
              </div>
              <p class="daystext">Days from Contract Date</p>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="f-12 mb-1">Balance Deposit Amount</label>
              <div class="w-100 d-flex align-items-center">
                <app-price-input [field_value]="contract.balanceDepositAmount" (onUpdate)="updatePrice($event, 'balance_deposit_amount')">
                </app-price-input>
              </div>
              <p class="daystext"></p>
            </div>
            <div class="col-sm-4 mt-xs-3">
              <p class="f-12 mb-1">Payable upon</p>
              <div class="w-100 d-flex align-items-center">
                <input
                  type="text"
                  name="balanceDepositAmountPayable"
                  [(ngModel)]="contract.balanceDepositAmountPayable"
                  class="doller-indent"
                  [ngClass]="{
                    '_input-error': isFormValueValid('balanceDepositAmountPayable') && !contract.balanceDepositAmountPayable,
                  }"
                  (input)="changeDue()" />
              </div>
              <p class="daystext">Days from Contract Date</p>
            </div>
            <div class="col-sm-4 mt-xs-3 mb-xs-3">
              <p class="f-12 mb-1">Finance Condition</p>
              <div class="w-100 d-flex align-items-center">
                <input
                  type="text"
                  name="financeTerm"
                  [(ngModel)]="contract.financeTerm"
                  class="doller-indent"
                  [ngClass]="{ '_input-error': isFormValueValid('financeTerm') && !contract.financeTerm }"
                  (input)="changeDue()" />
              </div>
              <p class="daystext">Days from Contract Date</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <button class="_outline-btn" (click)="addCondition()"><i class="pi pi-plus mr-2 f-10"></i>Add Further Condition</button>
            </div>
            <ng-container *ngIf="contract.condition?.length > 0">
              <ng-container *ngFor="let item of contract.condition; let ind = index">
                <div class="align-btn">
                  <div class="row w-100 mt-3">
                    <div class="col-sm-12 mb-xs-3 col-md-3 mb-2">
                      <input
                        type="text"
                        id="contractCondition-{{ ind }}"
                        name="contractCondition-{{ ind }}"
                        [(ngModel)]="item.contractCondition"
                        class="doller-indent" />
                    </div>
                    <div class="col-sm-6 mb-xs-3 col-md-3">
                      <div class="w-100 fx">
                        <p-calendar
                          name="finance"
                          [firstDayOfWeek]="1"
                          dateFormat="dd/mm/yy"
                          id="contractConditionDue-{{ ind }}"
                          name="contractConditionDue-{{ ind }}"
                          [(ngModel)]="item.contractConditionDue"
                          placeholder="Condition Due"
                          (onSelect)="selectDate('condition', ind)"
                          class="w-100">
                        </p-calendar>
                        <p class="ml-2 mr-2">or</p>
                      </div>
                    </div>
                    <div class="col-sm-6 mb-xs-3 col-md-3">
                      <input
                        type="text"
                        name="financeText"
                        id="contractConditionDueText-{{ ind }}"
                        name="contractConditionDueText-{{ ind }}"
                        [(ngModel)]="item.contractConditionDueText"
                        class="doller-indent" />
                    </div>
                    <div class="col-sm-12 col-md-3 mt-2">
                      <div class="p-field-checkbox">
                        <p-checkbox
                          [binary]="true"
                          id="contractConditionSatisfied-{{ ind }}"
                          name="contractConditionSatisfied-{{ ind }}"
                          inputId="binary"
                          [(ngModel)]="item.contractConditionSatisfied"></p-checkbox>
                        <label for="binary" class="ml-1 f-12">Satisfied</label>
                      </div>
                    </div>
                  </div>
                  <button class="preview-btn cs-width-35 px-2 mt-3" (click)="removeCondition(ind)">
                    <i class="pi pi-times f-16"></i>
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div class="row mt-3 justify-content-between">
            <div class="col-sm-12 col-md-6">
              <p class="mb-1">Comment to be included in offer to seller</p>
              <textarea class="h-auto cs-area" rows="4" cols="30" pInputTextarea [(ngModel)]="contract.comment"></textarea>
            </div>
            <div class="col-sm-2 mt-xs-3 mt-auto d-flex justify-content-end">
              <button class="_outline-btn" (click)="openModal()">Present Offer</button>
            </div>
          </div>
        </app-collapse-box>
      </div>

      <div class="form-group cs-border">
        <app-collapse-box
          [contractBorder]="'border-0'"
          [headingClassName]="'f-12'"
          [heading]="'Contract Terms'"
          [isCollapsed]="defaultFormSetting.contractTerms"
          (TriggerAction)="CollapseBoxActionTriggered($event)">
          <div class="row rowgap15">
            <div class="col-sm-4 col-md-3 position-relative">
              <p class="f-12 mb-1">Date Offer Received</p>
              <div class="w-100">
                <p-calendar
                  [ngClass]="{ '_input-error': isFormValueValid('dateOfferTerms') && !contract.dateOfferTerms }"
                  name="dateOfferTerms"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="contract.dateOfferTerms"
                  (onSelect)="selectDate('dateOfferTerms')">
                </p-calendar>
              </div>
            </div>

            <div class="col-sm-4 col-md-3">
              <p class="f-12 mb-1">Contract Issued Date</p>
              <div class="w-100">
                <p-calendar
                  name="contractIssuedDate"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  [ngClass]="{ '_input-error': isFormValueValid('contractIssuedDate') && !contract.contractIssuedDate }"
                  [(ngModel)]="contract.contractIssuedDate"
                  (onSelect)="selectDate('contractIssuedDate')">
                </p-calendar>
              </div>
            </div>

            <div class="col-sm-4 col-md-3">
              <p class="f-12 mb-1">Contract Received Date</p>
              <div class="w-100">
                <p-calendar
                  name="contractReceivedDate"
                  [firstDayOfWeek]="1"
                  [ngClass]="{ '_input-error': isFormValueValid('contractReceivedDate') && !contract.contractReceivedDate }"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="contract.contractReceivedDate"
                  (onSelect)="selectDate('contractReceivedDate')">
                </p-calendar>
              </div>
            </div>

            <div class="col-sm-4 col-md-3">
              <p class="f-12 mb-1">Contract Date</p>
              <div class="w-100">
                <p-calendar
                  name="contractDate"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  [ngClass]="{ '_input-error': isFormValueValid('contractDate') && !contract.contractDate }"
                  [(ngModel)]="contract.contractDate"
                  (onSelect)="selectDate('contractDate')">
                </p-calendar>
              </div>
            </div>

            <div class="col-sm-4 col-md-3">
              <label class="f-12 mb-1 mt-2">Cooling Off Expires</label>
              <div class="w-100">
                <p-calendar
                  name="collingExpire"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  [ngClass]="{ '_input-error': isFormValueValid('collingExpire') && !contract.collingExpire }"
                  [(ngModel)]="contract.collingExpire"
                  (onSelect)="selectDate('collingExpire')">
                </p-calendar>
              </div>
            </div>

            <div class="col-sm-4 col-md-3 position-relative">
              <label class="f-12 mb-1 mt-2">Contract Price</label>
              <app-price-input [field_value]="contract.contractPrice" (onUpdate)="updatePrice($event, 'contract_price')"> </app-price-input>
            </div>
            <div class="col-sm-4 col-md-3 mt-field">
              <label class="f-12 mb-1 mt-2">Unconditional Date</label>
              <p-calendar
                dateFormat="dd/mm/yy"
                name="unconditionalDate"
                [firstDayOfWeek]="1"
                [(ngModel)]="contract.unconditionalDate"
                (onSelect)="selectDate('unconditionalDate')"
                [ngClass]="{ '_input-error': isFormValueValid('unconditionalDate') && !contract.unconditionalDate }">
              </p-calendar>
            </div>

            <div class="col-sm-4 col-md-3 mt-field">
              <p class="f-12 mb-1 mt-2">Settlement Due</p>
              <div class="w-100 mt-2 mb-1">
                <p-calendar
                  dateFormat="dd/mm/yy"
                  name="settlement"
                  [firstDayOfWeek]="1"
                  [(ngModel)]="contract.settlement"
                  (onSelect)="selectDate('settlement')"
                  [ngClass]="{ '_input-error': isFormValueValid('settlement') && !contract.settlement }">
                </p-calendar>
              </div>
              <a class="mt-3 ml-1 f-10" href="https://www.timeanddate.com/date/weekdayadd.html?d1=&m1=&y1=&" target="_blank">Calendar Calculator</a>
            </div>
          </div>
          <div class="row rowgap15 mt-3">
            <div class="col-sm-4 col-md-3 position-relative">
              <label class="f-12 mb-1 mt-2">Initial Deposit</label>
              <app-price-input [field_value]="contract.initialDeposit" (onUpdate)="updatePrice($event, 'initial_deposit')"> </app-price-input>
            </div>
            <div class="col-sm-4 col-md-3 mt-field">
              <p class="f-12 mb-1 mt-2">Deposit Due</p>
              <div class="w-100">
                <p-calendar
                  name="depositDue"
                  [firstDayOfWeek]="1"
                  (onSelect)="selectDate('depositDue')"
                  [ngClass]="{ '_input-error': isFormValueValid('depositDue') && !contract.depositDue }"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="contract.depositDue">
                </p-calendar>
              </div>
            </div>
            <div class="col-sm-4 col-md-3">
              <div class="p-field-checkbox check-boxed mt-xs-0">
                <p-checkbox
                  [binary]="true"
                  name="depositDuePaid"
                  inputId="binary"
                  [ngClass]="{ '_input-error': isFormValueValid('depositDuePaid') && !contract.depositDuePaid }"
                  [(ngModel)]="contract.depositDuePaid"></p-checkbox>
                <label for="binary" class="ml-1 f-12">Paid</label>
              </div>
            </div>
            <div class="col-sm-4 col-md-3">
              <p class="f-12 mb-1 mt-2">Building & Pest Due</p>
              <div class="w-100">
                <p-calendar
                  name="pastDue"
                  [firstDayOfWeek]="1"
                  (onSelect)="selectDate('pastDue')"
                  [ngClass]="{ '_input-error': isFormValueValid('pastDue') && !contract.pastDue }"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="contract.pastDue">
                </p-calendar>
              </div>
            </div>
          </div>
          <div class="row rowgap15">
            <div class="col-sm-4 col-md-3 position-relative">
              <label class="f-12 mb-1 mt-2">Balance Deposit</label>
              <app-price-input [field_value]="contract.balanceDeposit" (onUpdate)="updatePrice($event, 'balance_deposit')"> </app-price-input>
            </div>
            <div class="col-sm-4 col-md-3 mt-field">
              <p class="f-12 mb-1 mt-2">Deposit Due</p>
              <div class="w-100">
                <p-calendar
                  name="balanceDepositDue"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  [ngClass]="{ '_input-error': isFormValueValid('balanceDepositDue') && !contract.balanceDepositDue }"
                  [(ngModel)]="contract.balanceDepositDue"
                  (onSelect)="selectDate('balanceDepositDue')">
                </p-calendar>
              </div>
            </div>
            <div class="col-sm-4 col-md-3">
              <div class="p-field-checkbox check-boxed mt-xs-0">
                <p-checkbox
                  [binary]="true"
                  inputId="binary"
                  name="balanceDepositDuePaid"
                  [ngClass]="{
                    '_input-error': isFormValueValid('balanceDepositDuePaid') && !contract.balanceDepositDuePaid,
                  }"
                  [(ngModel)]="contract.balanceDepositDuePaid"></p-checkbox>
                <label for="binary" name="balancePaid" class="ml-1 f-12">Paid</label>
              </div>
            </div>
            <div class="col-sm-4 col-md-3">
              <p class="f-12 mb-1 mt-2">Finance Due</p>
              <div class="w-100" name="financeDate">
                <p-calendar
                  name="financeDate"
                  [firstDayOfWeek]="1"
                  (onSelect)="selectDate('financeDate')"
                  [ngClass]="{ '_input-error': isFormValueValid('financeDate') && !contract.financeDate }"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="contract.financeDate">
                </p-calendar>
              </div>
            </div>
          </div>
          <div class="row rowgap15">
            <div class="col-sm-4 col-md-3">
              <label class="f-12 mb-1 mt-2">Total Deposit</label>
              <app-price-input [field_value]="contract.totalDeposit" (onUpdate)="updatePrice($event, 'total_deposit')"> </app-price-input>
            </div>
            <div class="col-sm-4 col-md-3">
              <div class="p-field-checkbox check-boxed mt-xs-0">
                <p-checkbox
                  [binary]="true"
                  name="financeDateSatisfied"
                  [(ngModel)]="contract.financeDateSatisfied"
                  inputId="binary"
                  [ngClass]="{
                    '_input-error': isFormValueValid('financeDateSatisfied') && !contract.financeDateSatisfied,
                  }"></p-checkbox>
                <label for="binary" class="ml-1 f-12">Contract Satisfied</label>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="mt-2 mb-2 d-flex justify-content-between">
                <p class="f-12 _fw-600 mb-1 mt-2">Further Conditions</p>
                <button class="_outline-btn" (click)="addCondition()"><i class="pi pi-plus mr-2 f-10"></i>Add Further Condition</button>
              </div>
            </div>

            <ng-container *ngIf="contract.condition?.length > 0">
              <ng-container *ngFor="let item of contract.condition; let ind = index">
                <div class="align-btn">
                  <div class="row w-100">
                    <div class="col-sm-12 mb-xs-3 col-md-3 mb-2">
                      <input
                        type="text"
                        id="contractCondition-{{ ind }}"
                        name="contractCondition-{{ ind }}"
                        [(ngModel)]="item.contractCondition"
                        class="doller-indent" />
                    </div>
                    <div class="col-sm-6 mb-xs-3 col-md-3">
                      <div class="w-100 fx">
                        <p-calendar
                          name="finance"
                          [firstDayOfWeek]="1"
                          dateFormat="dd/mm/yy"
                          id="contractConditionDue-{{ ind }}"
                          name="contractConditionDue-{{ ind }}"
                          [(ngModel)]="item.contractConditionDue"
                          placeholder="Condition Due"
                          (onSelect)="selectDate('condition', ind)"
                          class="w-100">
                        </p-calendar>
                        <p class="ml-2 mr-2">or</p>
                      </div>
                    </div>
                    <div class="col-sm-6 mb-xs-3 col-md-3">
                      <input
                        type="text"
                        name="financeText"
                        id="contractConditionDueText-{{ ind }}"
                        name="contractConditionDueText-{{ ind }}"
                        [(ngModel)]="item.contractConditionDueText"
                        class="doller-indent" />
                    </div>
                    <div class="col-sm-12 col-md-3 mt-2">
                      <div class="p-field-checkbox">
                        <p-checkbox
                          [binary]="true"
                          id="contractConditionSatisfied-{{ ind }}"
                          name="contractConditionSatisfied-{{ ind }}"
                          inputId="binary"
                          [(ngModel)]="item.contractConditionSatisfied"></p-checkbox>
                        <label for="binary" class="ml-1 f-12">Satisfied</label>
                      </div>
                    </div>
                  </div>
                  <button class="preview-btn cs-width-35 px-2" (click)="removeCondition(ind)">
                    <i class="pi pi-times f-16"></i>
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </app-collapse-box>
      </div>

      <div class="form-group cs-border">
        <app-collapse-box
          [contractBorder]="'border-0'"
          [headingClassName]="'f-12'"
          [heading]="'Additional Information'"
          [isCollapsed]="defaultFormSetting.additionalInformation"
          (TriggerAction)="CollapseBoxActionTriggered($event)">
          <div class="row">
            <div class="col-sm-6 col-md-4 mb-xs-3">
              <label class="f-12 mb-1">Foreign</label>
              <ng-select
                [items]="foreign"
                [(ngModel)]="contract.foreign"
                name="foreign"
                bindLabel="tag_name"
                bindValue="tag_name"
                [searchable]="true"
                [clearable]="false"
                [ngClass]="{ '_input-error': isFormValueValid('foreign') && !contract.foreign }"
                placeholder="Select">
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-4 mb-sm-3 mb-xs-3">
              <label class="f-12 mb-1">Owner Occupier / Investor</label>
              <ng-select
                [items]="occupier_investor"
                [(ngModel)]="contract.ownerOccupier"
                name="ownerOccupier"
                bindLabel="tag_name"
                bindValue="tag_name"
                [searchable]="true"
                [clearable]="false"
                [ngClass]="{ '_input-error': isFormValueValid('ownerOccupier') && !contract.ownerOccupier }"
                placeholder="Select">
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-4">
              <label class="f-12 mb-1">Deposit Stakeholder</label>
              <input
                type="text"
                name="depositStakeholder"
                [ngClass]="{ '_input-error': isFormValueValid('depositStakeholder') && !contract.depositStakeholder }"
                [(ngModel)]="contract.depositStakeholder" />
            </div>
          </div>
        </app-collapse-box>
      </div>
    </div>
    <div class="col-xl-4 bg-white cs-left-border">
      <div class="d-flex align-items-center primary-tabs b-b-tabs">
        <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
          <li (click)="is_history = false; is_notes = false">
            <a class="active" data-bs-toggle="tab" role="tab" href="javascript:void(0)" data-bs-target="#contract_document"
              ><img [src]="images?.contract_document" alt="documents" class="mr-1" width="14px" /> Documents</a
            >
          </li>
          <li (click)="is_history = false; is_notes = true">
            <a class="" data-bs-toggle="tab" role="tab" name="note" href="javascript:void(0)" data-bs-target="#contract_notes"
              ><img [src]="common_images?.notes" width="14px" alt="notes" class="mr-1" />
              Notes
              <p class="ml-2 a-head-badge" *ngIf="pinned_notes?.length > 0">{{ pinned_notes?.length }}</p>
            </a>
          </li>
          <li (click)="is_history = true; is_notes = false">
            <a data-bs-toggle="tab" role="tab" href="javascript:void(0)" data-bs-target="#contract_history"
              ><i class="pi pi-history f-12 mr-1"></i> History</a
            >
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <div id="contract_document" class="tab-pane fade show active">
          <div class="sticky-sidebar">
            <ng-container *ngIf="lmService.contract_show_div == 'add_contract' && !insertedId">
              <p class="my-2">Please save your contract before uploading any files</p>
            </ng-container>
            <div class="site-card p-4 w-100 lib-content px-3 library cs-box-shadow" [ngClass]="{ 'mb-12': property_id?.length > 0 }">
              <app-library-view-mode
                *ngIf="lmService.contract_show_div == 'edit_contract' || insertedId"
                category="useroffice"
                [propertyId]="contract.listingid || property_id"
                [isContractLibrary]="true"
                [contract_Id]="contractId == 'createnew' ? insertedId : contractId"
                defaultopen="{{ insertedId || contractId }}"
                (LibraryOutputData)="GetLibraryData($event)"
                [hidePropertyLibrary]="true">
              </app-library-view-mode>
            </div>
          </div>
        </div>
        <div id="contract_notes" class="tab-pane fade">
          <div *ngIf="is_notes" class="mx-3 mt-2">
            <app-notes [moduleId]="this.selected_contract" (pinnedNotes)="getNotes($event)"></app-notes>
          </div>
        </div>
        <div id="contract_history" class="tab-pane fade">
          <ng-container *ngIf="is_history == true">
            <app-remmi-history [module]="'Contract'" [record_id]="contractId || insertedId"></app-remmi-history>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="offset-xl-8 col-xl-4 d-flex justify-content-end form-header">
      <div class="mb-5" *ngIf="lmService.contract_show_div == 'add_contract'">
        <button class="_cancel-btn mr-2" (click)="closeContract()">Cancel</button>
        <button class="mr-2 _outline-btn" (click)="singleClick = true; saveContract('onlySave', contractForm)" [class.disabled]="singleClick">
          Save
        </button>
        <button class="_primary-btn" (click)="singleClick = true; saveContract('save', contractForm)" [class.disabled]="singleClick">
          Save & Close
        </button>
      </div>
      <div
        class="mb-5"
        *ngIf="
          lmService.contract_show_div == 'edit_contract' &&
          (this.userPermission.includes('contract.manage') ||
            this.userPermission.includes('contract.edit') ||
            this.userRole == 'master admin' ||
            this.userRole == 'operations manager')
        ">
        <button class="_cancel-btn mr-2" (click)="closeContract()">Cancel</button>
        <button class="mr-2 _outline-btn" (click)="singleClick = true; updateContract('onlySave', contractForm)" [class.disabled]="singleClick">
          Save
        </button>
        <button class="_primary-btn" (click)="singleClick = true; updateContract('save', contractForm)" [class.disabled]="singleClick">
          Save & Close
        </button>
      </div>
    </div>
  </div>
</form>

<app-confirmation-dialog #contractDeleteDialog (confirmed)="sendEmail(); editContractForm()" primary_btn_name="Send" [title]="'Present Offer'">
  <div class="p-offer">
    <div class="col-sm-12 mt-0">
      <label class="f-12 mb-1">To</label>
      <label for="" class="w-100">
        <re-multiselect
          [module]="'contacts'"
          [truncate]="13"
          [selected_ids]="contractEmail.to"
          (onUpdate)="onUpdateMSelect($event, 'to')"
          [placeholder]="'Select To'"
          [isEmail]="true"
          (createNew)="openRightModal(null, 'add_contact')"
          [isCreateNew]="true"
          [style]="{ width: '100%' }">
        </re-multiselect>
      </label>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <p>Email CC</p>
      <button class="email-add" (click)="addEmailCC()"><i class="pi pi-plus f-12"></i></button>
    </div>
    <div class="user-view-workarea px-0 pb-0">
      <form class="form">
        <div class="create-user-form">
          <ng-container *ngFor="let item of email_cc; let ind = index">
            <div class="row">
              <div class="col-md-4 col-xs-9">
                <div class="form-group mb-2">
                  <ng-select
                    [items]="selectAssign"
                    bindLabel="name"
                    bindValue="value"
                    [searchable]="false"
                    [(ngModel)]="item.type"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Please Select"
                    [multiple]="false"
                    (change)="item.email_cc = null"
                    class="w-76 mb-1 trigger-Name"
                    name="all_user_receiver_type"
                    id="all_user_receiver_type">
                  </ng-select>
                </div>
              </div>
              <div class="col-md-7" *ngIf="item.type">
                <ng-container *ngIf="item.type === 'staff'">
                  <div class="form-group mb-2 pad-left">
                    <re-multiSelect
                      [options]="contractService.office_staff"
                      [(selectedOptions)]="item.email_cc"
                      optionLabel="full_name"
                      optionValue="email"
                      placeholder="Agent"
                      [isEmail]="true">
                    </re-multiSelect>
                  </div>
                </ng-container>
                <ng-container *ngIf="item.type === 'contact'">
                  <div class="form-group mb-2 pad-left">
                    <re-multiselect
                      [module]="'contacts'"
                      [truncate]="30"
                      [selected_ids]="item.email_cc"
                      (onUpdate)="onUpdateMSelect($event, '', ind)"
                      [placeholder]="'Select Contact'"
                      [style]="{ width: '100%' }"
                      [isEmail]="true">
                    </re-multiselect>
                  </div>
                </ng-container>
              </div>
              <div class="col-md-1 col-xs-3 pt-1 p-0 pl-1">
                <div class="form-group">
                  <label for=""></label>
                  <img [src]="images?.close_icon" alt="remove" width="24px" class="cursor-pointer" (click)="removeEmailCC(ind)" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div class="col-sm-12 mt-2">
      <label class="f-12 mb-1">Select Template</label>
      <ng-select
        [items]="emailTemplates"
        [(ngModel)]="contractEmail.emailTemplate"
        name="emailTemplate"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        (change)="getTemplateBody($event)"
        [clearable]="false"
        placeholder="Email Template">
      </ng-select>
    </div>
    <div class="col-sm-12 mt-2">
      <label class="f-12 mb-1">Subject</label>
      <input type="text" name="subject" [(ngModel)]="contractEmail.subject" />
    </div>
    <div class="col-sm-12 mt-2 _paragraph">
      <label class="f-12 mb-1">Body</label>
      <ckeditor [(ngModel)]="contractEmail.body" class="gmail-box" [editor]="Editor"> </ckeditor>
    </div>
  </div>
</app-confirmation-dialog>
